document.addEventListener('DOMContentLoaded', function () {
  /**
   * Retrieves a value from localStorage with expiry check.
   * @param {string} key - The key of the item to retrieve.
   * @returns {*} - The value associated with the key, or null if the item is expired or doesn't exist.
   */
  function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }

  /**
   * Sets a value in the local storage with an expiry time.
   * @param {string} key - The key to set the value with.
   * @param {any} value - The value to be stored.
   */
  function setWithExpiry(key, value) {
    const now = new Date()
    const ttl = 60 * 60 * 24

    // `item` is an object which contains the original value
    // as well as the time when it's supposed to expire
    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  var curentInterval = null
  /**
   * Starts a timer with the given duration and updates the display element with the remaining time.
   * @param {number} duration - The duration of the timer in seconds.
   * @param {HTMLElement} display - The element where the remaining time will be displayed.
   */
  function startTimer(duration, display) {
    var timer = getWithExpiry('cartTimer'),
      minutes,
      seconds
    curentInterval = setInterval(function () {
      var display = display || document.querySelector('#cartCountdown') || 1

      minutes = parseInt(timer / 60, 10)
      seconds = parseInt(timer % 60, 10)

      minutes = minutes < 10 ? '0' + minutes : minutes
      seconds = seconds < 10 ? '0' + seconds : seconds

      if (display) {
        display.textContent = minutes + ':' + seconds
      }
      setWithExpiry('cartTimer', timer)
      if (--timer < 0) {
        timer = duration
        if (display) {
          if (document.querySelector('.cartCountdownAlert')) {
            document.querySelector('.cartCountdownAlert').style.display = 'none'
          }
          document.querySelector('#sidebar-cart')?.classList?.add?.('hideAlert')
        }
        clearInterval(curentInterval)
      }
    }, 1000)
  }

  var tenMinutes = 60 * 10
  var display = document.querySelector('#cartCountdown')
  var currentValue = getWithExpiry('cartTimer')

  if (display && currentValue > 0 && currentValue !== null) {
    startTimer(tenMinutes, display)
  } else {
    if (document.querySelector('.cartCountdownAlert')) {
      document.querySelector('.cartCountdownAlert').style.display = 'none'
      document.querySelector('#sidebar-cart').classList.add('hideAlert')
    }
  }

  /**
   * Initializes the timer for the cart countdown.
   * @param {Event} e - The event object.
   */
  var initTimer = function (e) {
    var display = document.querySelector('#cartCountdown')
    var currentValue = parseInt(getWithExpiry('cartTimer'))
    if (!curentInterval && (currentValue > 0 || currentValue === null || isNaN(currentValue))) {
      setWithExpiry('cartTimer', tenMinutes)
      startTimer(tenMinutes, display)
    }
    if (currentValue == 0 || isNaN(currentValue)) {
      console.log('VALUE NULL')
      document.querySelector('#sidebar-cart').classList.add('hideAlert')
    }
  }

  initTimer()

  document.addEventListener('product:added', function () {
    document.querySelector('#sidebar-cart').classList.remove('hideAlert')
    clearInterval(curentInterval)
    setWithExpiry('cartTimer', tenMinutes)
    startTimer(tenMinutes, display)
  })
  document.addEventListener('product:quantity:change', function () {
    document.querySelector('#sidebar-cart').classList.remove('hideAlert')
    console.log('product:quantity:change')
    clearInterval(curentInterval)
    setWithExpiry('cartTimer', tenMinutes)
    startTimer(tenMinutes, display)
  })
})
